var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 114,
    viewBox: "0 0 80 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.1306 15.9355C36.4256 27.9137 25.1042 48.6925 25.1042 71.0306V113.332L32.4409 108.17C46.5165 98.271 54.568 80.8943 54.568 70.4518L53.5366 69.5658C47.9463 64.7698 48.6026 55.8866 54.8376 51.9765C70.507 41.9356 80.0001 24.5235 80.0001 5.81192V0L55.1306 15.9355Z",
    fill: "url(#paint0_linear_28_224)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0169 75.8741C54.3685 74.3739 54.5677 70.452 54.5677 70.452C54.5677 48.1139 43.5745 27.914 24.8696 15.924L0 0.000244141V5.85941C0 24.5473 9.48137 41.9358 25.1274 51.9531L49.0008 66.6247C49.0008 66.6247 54.7552 70.0622 54.0169 75.8623V75.8741Z",
    fill: "url(#paint1_linear_28_224)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28_224",
    x1: 88.5673,
    y1: 7.24127,
    x2: 6.64195,
    y2: 98.9814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81E0B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338368,
    stopColor: "#8EE896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504563,
    stopColor: "#5EC968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.579971,
    stopColor: "#4DAC56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732658,
    stopColor: "#7CE186"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99EBA1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_28_224",
    x1: 15.775,
    y1: 48.7524,
    x2: 41.3732,
    y2: 29.8556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67D79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#60D26C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#89E5A0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/LogoIcon.f9c1ca135c7201e3115d8f71edc5f64c.svg";
export { ForwardRef as ReactComponent };